<div class="container second-holder-page">
  <h1 class="h-main">{{ 'summary_sec_holder_title' | translate }}</h1>
  <p class="info-text">
    <span> {{ 'summary_sec_holder_info_1' | translate }} </span>

    @if (dataSimulate?.status === 'MTG_E04.3') {
      <span>
        {{ 'summary_sec_holder_info_2' | translate }}
      </span>
    }
  </p>
  <div class="row">
    <h2 class="h-main h-main-medium corporate col-12">
      {{ 'summary_sec_holder_subtitle' | translate }}
    </h2>
    <div class="col-12">
      <div class="primary-info-box advanced-result mortgage-info">
        <div class="row date-row">
          <div class="col-7 text-align-left">
            <h3 class="amount">
              {{ 'summary_sec_holder_mortgage_amount' | translate }}
            </h3>
          </div>
          <div class="col-5 text-align-right">
            @if (dataSimulate?.mortgageAmount) {
              <h3 id="rsult-mortgageAmount" class="amount nowrap">
                {{ dataSimulate?.mortgageAmount | number: '1.0-0' }} €
              </h3>
            }
          </div>
        </div>
        <div class="row date-row">
          <div class="col-8 text-align-left">
            <span>{{ 'summary_sec_holder_financing_percentage' | translate }}</span>
          </div>
          @if (dataSimulate?.mortgageSimulateResponse?.mortgageResult?.calculation?.ltv) {
            <div class="col-4 text-align-right">
              <span id="summary-sec-holder-ltv">
                {{ dataSimulate?.mortgageSimulateResponse?.mortgageResult?.calculation?.ltv * 100 | number: '1.2-2' }}
                %</span
              >
            </div>
          }
        </div>
        <div class="row date-row">
          <div class="col-8 text-align-left">
            <span>{{ 'summary_sec_holder_duration_in_years' | translate }}</span>
          </div>
          <div class="col-4 text-align-right">
            <span id="summary-sec-holder-termInYears">
              {{ dataSimulate?.termInYears }}
              {{ 'label_years_mortgage_product_postpone' | translate }}</span
            >
          </div>
        </div>
        <div class="row date-row">
          <div class="col-8 text-align-left">
            <span class="amount cuote">
              {{ 'summary_sec_holder_first_year_monthly_fee' | translate }}
            </span>
            <a
              class="icon-a"
              href="javascript:void(0)"
              tooltipEvent="focus"
              appOpenToast
              id="simulation-result-tooltip-first-year-monthy-fee"
              [pTooltip]="'simulation-result-tooltip-first-year-monthy-fee' | translate"
            >
              <img class="ico-info" src="assets/img/info.svg" title="Haz clic para más información" />
            </a>
          </div>
          <div class="col-4 text-align-right">
            @if (dataSimulate?.mortgageSimulateResponse?.mortgageResult?.calculation?.monthlyFeeY1) {
              <span id="summary-sec-holder-monthlyFeeY1" class="amount cuote nowrap">
                {{
                  dataSimulate?.mortgageSimulateResponse?.mortgageResult?.calculation?.monthlyFeeY1 | number: '1.2-2'
                }}
                €</span
              >
            }
          </div>
        </div>
        <div class="row date-row">
          <div class="col-8 text-align-left">
            <span class="amount cuote">
              {{ 'summary_sec_holder_monthly_fee_other_years' | translate }}
            </span>
          </div>
          <div class="col-4 text-align-right">
            @if (dataSimulate?.mortgageSimulateResponse?.mortgageResult?.calculation?.monthlyFee) {
              <span id="summary-sec-holder-monthlyFee" class="amount cuote nowrap">
                {{ dataSimulate?.mortgageSimulateResponse?.mortgageResult?.calculation?.monthlyFee | number: '1.2-2' }}
                €</span
              >
            }
          </div>
        </div>
        <div class="row date-row">
          <div class="col-6 order-md-first text-align-left">
            <h3 id="summary-sec-holder-btn-modal-taxes" class="h-sub-section">
              <span
                >{{ 'summary_sec_holder_taxes' | translate }}
                <a class="btn btn-03" (click)="openModal('taxes')"
                  >{{ 'summary_sec_holder_btn_show_taxes' | translate }}
                </a></span
              >
            </h3>
          </div>
          <div class="col-6 text-align-right">
            <span id="summary-sec-holder-totalExpenses">{{ totalExpenses | number: '1.2-2' }} € </span>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="row date-row">
              <div class="col-md-2 col-6 text-align-left">
                <span>
                  {{ 'summary_sec_holder_tin_one_year' | translate }}
                </span>
                <a
                  class="icon-a"
                  href="javascript:void(0)"
                  tooltipEvent="focus"
                  appOpenToast
                  id="simulation-result-tooltip-tin-one-year"
                  [pTooltip]="'tooltip_tin_first_year' | translate"
                >
                  <img class="ico-info" src="assets/img/info.svg" title="Haz clic para más información" />
                </a>
              </div>
              <div class="col-md-2 col-6 text-align-right">
                @if (dataSimulate?.mortgageSimulateResponse?.mortgageResult?.calculation?.tinY1) {
                  <span id="summary-sec-holder-tinY1"
                    >{{
                      dataSimulate?.mortgageSimulateResponse?.mortgageResult?.calculation?.tinY1 | number: '1.2-2'
                    }}
                    %</span
                  >
                }
              </div>
              <div class="col-md-2 col-6 text-align-left">
                <span class="nowrap">
                  {{ 'summary_sec_holder_euribor' | translate }}
                </span>
              </div>
              <div class="col-md-2 col-6 text-align-right">
                @if (dataSimulate?.mortgageSimulateResponse?.mortgageResult?.calculation?.differential) {
                  <span id="summary-sec-holder-differential"
                    >+{{
                      dataSimulate?.mortgageSimulateResponse?.mortgageResult?.calculation?.differential
                        | number: '1.2-2'
                    }}
                    %</span
                  >
                }
              </div>
              <div class="col-md-2 col-6 text-align-left">
                <span> {{ 'summary_sec_holder_tae' | translate }} </span>
              </div>
              <div class="col-md-2 col-6 text-align-right">
                @if (dataSimulate?.mortgageSimulateResponse?.mortgageResult?.calculation?.tae) {
                  <span id="summary-sec-holder-tae"
                    >{{
                      dataSimulate?.mortgageSimulateResponse?.mortgageResult?.calculation?.tae | number: '1.2-2'
                    }}
                    %</span
                  >
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- revisión de datos del segundo titular -->
  <div class="row">
    <h2 class="h-main h-main-medium corporate col-12">
      {{ 'summary_sec_holder_data' | translate }}
    </h2>
    <div class="col-12">
      <div class="recipient primary-info-box advanced-result">
        <div class="row colapsable">
          <div class="col-12 no-pd">
            <div class="col-12">
              <!-- <h3 class="h-sub-section">
                                 Titular Titular Titular
                          </h3> -->
              <div class="colapsable-content visible">
                <div class="row">
                  <h4 class="col-12 h-title">
                    {{ 'summary_sec_holder_personal_data' | translate }}
                  </h4>
                  <div class="col-12">
                    <div class="alert alert-info document-info">
                      <p>
                        <span class="uppercase">Importante: </span>Comprueba que tu nombre y apellidos están escritos
                        tal y como aparecen en tu documento de identidad (NIE, NIF...)
                      </p>
                    </div>
                  </div>
                  <div class="col-lg-6 col-12">
                    <div class="row date-row">
                      <div class="col-12">
                        <span class="recipient-label">
                          {{ 'summary_sec_holder_name' | translate }}
                        </span>
                      </div>
                      <div class="col-12">
                        <span id="summary-sec-holder-name" class="recipient-data">{{
                          dataSimulate?.holder?.name
                        }}</span>
                      </div>
                    </div>
                    <div class="row date-row">
                      <div class="col-12">
                        <span class="recipient-label">
                          {{ 'summary_sec_holder_surname' | translate }}
                        </span>
                      </div>
                      <div class="col-12">
                        <span id="summary-sec-holder-firstSurname" class="recipient-data">{{
                          dataSimulate?.holder?.firstSurname
                        }}</span>
                      </div>
                    </div>
                    <div class="row date-row">
                      <div class="col-12">
                        <span class="recipient-label">
                          {{ 'summary_sec_holder_second_surname' | translate }}
                        </span>
                      </div>
                      <div class="col-12">
                        <span id="summary-sec-holder-secondSurname" class="recipient-data">{{
                          dataSimulate?.holder?.secondSurname
                        }}</span>
                      </div>
                    </div>
                    <div class="row date-row">
                      <div class="col-12">
                        <span class="recipient-label">
                          {{ 'summary_sec_holder_document_type' | translate }}
                        </span>
                      </div>
                      <div class="col-12">
                        <span id="summary-sec-holder-idType" class="recipient-data">{{
                          dataSimulate?.holder?.idType | translate
                        }}</span>
                      </div>
                    </div>
                    <div class="row date-row w-border">
                      <div class="col-12">
                        <span class="recipient-label">
                          {{ 'summary_sec_holder_id_number' | translate }}
                        </span>
                      </div>
                      <div class="col-12">
                        <span id="summary-sec-holder-idNumber" class="recipient-data">{{
                          dataSimulate?.holder?.idNumber
                        }}</span>
                      </div>
                    </div>
                    <div class="row date-row w-border-mobile">
                      <div class="col-12">
                        <span class="recipient-label">
                          {{ 'summary_sec_holder_gender' | translate }}
                        </span>
                      </div>
                      <div class="col-12">
                        <span id="summary-sec-holder-gender" class="recipient-data">{{
                          dataSimulate?.holder?.gender
                            ? ('summary_sec_holder_' + dataSimulate?.holder?.gender | translate)
                            : ''
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 col-12">
                    <div class="row date-row">
                      <div class="col-12">
                        <span class="recipient-label">
                          {{ 'summary_sec_holder_birthday' | translate }}
                        </span>
                      </div>
                      <div class="col-12">
                        <span id="summary-sec-holder-birthDate" class="recipient-data"
                          >{{ dataSimulate?.holder?.birthDate | date }}
                        </span>
                      </div>
                    </div>
                    <div class="row date-row">
                      <div class="col-12">
                        <span class="recipient-label">
                          {{ 'summary_sec_holder_email' | translate }}
                        </span>
                      </div>
                      <div class="col-12">
                        <span id="summary-sec-holder-email" class="recipient-data"
                          >{{ dataSimulate?.holder?.email }}
                        </span>
                      </div>
                    </div>
                    <div class="row date-row">
                      <div class="col-12">
                        <span class="recipient-label">
                          {{ 'summary_sec_holder_marital_status' | translate }}
                        </span>
                      </div>
                      <div class="col-12">
                        <span id="summary-sec-holder-maritalStatus" class="recipient-data">{{
                          dataSimulate?.holder?.maritalStatus | translate
                        }}</span>
                      </div>
                    </div>
                    <div class="row date-row">
                      <div class="col-12">
                        <span class="recipient-label">
                          {{ 'summary_sec_holder_phone' | translate }}
                        </span>
                      </div>
                      <div class="col-12">
                        <span id="summary-sec-holder-phone" class="recipient-data">{{
                          dataSimulate?.holder?.phone
                        }}</span>
                      </div>
                    </div>
                    <div class="row date-row">
                      <div class="col-12">
                        <span class="recipient-label">
                          {{ 'summary_sec_holder_country' | translate }}
                        </span>
                      </div>
                      <div class="col-12">
                        <span id="summary-sec-holder-country" class="recipient-data">{{
                          dataSimulate?.holder?.country
                        }}</span>
                      </div>
                    </div>
                    <div class="row date-row">
                      <div class="col-12">
                        <span class="recipient-label">
                          {{ 'summary_sec_holder_nationality' | translate }}
                        </span>
                      </div>
                      <div class="col-12">
                        <span id="summary-sec-holder-nationality" class="recipient-data">{{
                          dataSimulate?.holder?.nationality
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <hr class="divider" />
                  <h4 class="col-12 h-title">
                    {{ 'summary_sec_holder_address' | translate }}
                  </h4>
                  <div class="col-12">
                    <div class="row date-row">
                      <div class="col-12">
                        <span class="recipient-data">
                          @if (
                            dataSimulate?.holder?.holderAddress.roadType && dataSimulate?.holder?.holderAddress.roadName
                          ) {
                            <span class="recipient-data">
                              {{ dataSimulate?.holder?.holderAddress.roadType | translate }}
                              {{ dataSimulate?.holder?.holderAddress.roadName }},
                            </span>
                          }

                          @if (dataSimulate?.holder?.holderAddress.roadNumber) {
                            <span class="recipient-data">nº{{ dataSimulate?.holder?.holderAddress.roadNumber }}</span>
                          }

                          @if (dataSimulate?.holder?.holderAddress.doorway) {
                            <span class="recipient-data">
                              portal
                              {{ dataSimulate?.holder?.holderAddress.doorway }}
                            </span>
                          }
                          {{ dataSimulate?.holder?.holderAddress.floor }}
                          {{ dataSimulate?.holder?.holderAddress.door }}
                          {{ dataSimulate?.holder?.holderAddress.zip }}
                          {{ dataSimulate?.holder?.holderAddress.city }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <hr class="divider" />
                  <h4 class="col-12 h-title">
                    {{ 'summary_sec_holder_economic_data' | translate }}
                  </h4>
                  <div class="col-lg-6 col-12">
                    <div class="row date-row">
                      <div class="col-12">
                        <span class="recipient-label">
                          {{ 'summary_sec_holder_monthly_income' | translate }}
                        </span>
                      </div>
                      <div class="col-12">
                        @if (dataSimulate?.holder?.holderEmploymentData?.monthlyIncome) {
                          <span class="recipient-data"
                            >{{ dataSimulate?.holder?.holderEmploymentData?.monthlyIncome | number: '1.2-2' }} €</span
                          >
                        }
                      </div>
                    </div>
                    <div class="row date-row">
                      <div class="col-12">
                        <span class="recipient-label">
                          {{ 'summary_sec_holder_other_income' | translate }}
                        </span>
                      </div>
                      <div class="col-12">
                        @if (dataSimulate?.holder?.holderEmploymentData?.otherIncome) {
                          <span id="summary-sec-holder-otheIncome" class="recipient-data"
                            >{{ dataSimulate?.holder?.holderEmploymentData?.otherIncome | number: '1.2-2' }} €</span
                          >
                        }

                        @if (dataSimulate?.holder?.holderEmploymentData?.otherIncome === '') {
                          <span id="summary-sec-holder-otheIncome" class="recipient-data"
                            >{{ 0 | number: '1.2-2' }} €</span
                          >
                        }
                      </div>
                    </div>
                    <div class="row date-row">
                      <div class="col-12">
                        <span class="recipient-label">
                          {{ 'summary_sec_holder_employement_situation' | translate }}
                        </span>
                      </div>
                      <div class="col-12">
                        <span id="summary-sec-holder-employmentSituation" class="recipient-data">{{
                          dataSimulate?.holder?.holderEmploymentData?.employmentSituation | translate
                        }}</span>
                      </div>
                    </div>
                    <div class="row date-row w-border-mobile">
                      <div class="col-12">
                        <span class="recipient-label">
                          {{ 'NIVEL DE ESTUDIOS' | translate }}
                        </span>
                      </div>
                      <div class="col-12">
                        <span id="summary-sec-holder-employmentSituation" class="recipient-data">{{
                          dataSimulate?.holder?.holderEmploymentData?.academicLevel | translate
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 col-12">
                    <div class="row date-row">
                      <div class="col-12">
                        <span class="recipient-label">
                          {{ 'summary_sec_holder_company_name' | translate }}
                        </span>
                      </div>
                      <div class="col-12">
                        <span id="summary-sec-holder-companyName" class="recipient-data">{{
                          dataSimulate?.holder?.holderEmploymentData?.companyName
                        }}</span>
                      </div>
                    </div>
                    <div class="row date-row">
                      <div class="col-12">
                        <span class="recipient-label">
                          {{ 'summary_sec_holder_seniority_company' | translate }}
                        </span>
                      </div>
                      <div class="col-12">
                        <span id="summary-sec-holder-laborSeniority" class="recipient-data">{{
                          dataSimulate?.holder?.holderEmploymentData?.laborSeniority | translate
                        }}</span>
                      </div>
                    </div>
                    <div class="row date-row w-border">
                      <div class="col-12">
                        <span class="recipient-label">
                          {{ 'summary_sec_holder_activity_sector' | translate }}
                        </span>
                      </div>
                      <div class="col-12">
                        <span id="summary-sec-holder-laborSeniority" class="recipient-data">{{
                          dataSimulate?.holder?.holderEmploymentData?.activitySector | translate
                        }}</span>
                      </div>
                    </div>
                    <div class="row date-row w-border-mobile">
                      <div class="col-12">
                        <span class="recipient-label">
                          {{ 'summary_sec_holder_professional_level' | translate }}
                        </span>
                      </div>
                      <div class="col-12">
                        <span id="summary-sec-holder-professional-level" class="recipient-data">{{
                          dataSimulate?.holder?.holderEmploymentData?.professionalLevel | translate
                        }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <hr class="divider" *ngIf="indice === 0 && personalData?.level2Data?.holders?.length > 1"> -->
          </div>
        </div>
      </div>
    </div>
    <!-- botones -->

    @if (dataSimulate?.status === 'MTG_E04.3') {
      <div class="container">
        <p class="info-text">
          <span> {{ 'summary_sec_holder_title_btns' | translate }} </span>
        </p>
      </div>
    }

    @if (dataSimulate?.status === 'MTG_E04.3') {
      <div class="d-flex justify-content-end second-holder-btn-group">
        <a class="btn btn-01" (click)="openModal('editData')">
          {{ 'summary_sec_holder_btn_modify' | translate }}
        </a>
        <a class="btn btn-01" (click)="openModal('deleteData')">
          {{ 'summary_sec_holder_btn_incorret_data' | translate }}
        </a>
        <a class="btn btn-02" (click)="openModal('confirmData')">
          {{ 'summary_sec_holder_btn_confirm_data' | translate }}
        </a>
      </div>
    }
  </div>
</div>
